import { fetchDevices } from '#action/device/devices-paginated';
import { DeviceTypeFilterOptionService, ProjectsFilterOptionService } from '#service/autocomplete-service/service';
import { FilterOption } from '#service/autocomplete-service/option';
import { uuidv4 } from '#helper';

const occupiedByOptions = [
  { label: 'All', value: '0', id: '0', default: true },
  { label: 'Active', value: '1', id: '1' },
  { label: 'Inactive', value: '2', id: '2' }
];

const searchProps = {
  type: 'Search',
  name: 'search',
  label: 'Search a device',
  relatedTo: 'device',
  id: uuidv4()
};

const deviceTypeComponent = {
  type: 'MultipleSelect',
  name: 'deviceType',
  label: 'Device type',
  mobileLabel: 'Choose device type',
  relatedTo: 'device',
  id: uuidv4(),
  fetchOptionsService: DeviceTypeFilterOptionService,
  searchFields: ['label']
};

const projectComponent = {
  type: 'MultipleSelect',
  name: 'project',
  label: 'Project',
  mobileLabel: 'Choose project',
  relatedTo: 'device',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const deviceOccupiedByComponent = {
  type: 'RadioButtonsGroup',
  name: 'occupied',
  label: 'Device status',
  mobileLabel: 'Device occupancy',
  relatedTo: 'device',
  id: uuidv4(),
  options: occupiedByOptions.map(o => new FilterOption(o, o.label))
};

const filterConfig = {
  customActions: {
    fetchFilterData: fetchDevices
  },
  searchProps,
  components: [deviceTypeComponent, projectComponent, deviceOccupiedByComponent]
};

export default filterConfig;
